'use strict';


angular.module('app').config(['$routeProvider',
  function ($routeProvider) {
    var __timestamp__ = '?.1775644577349',
      routes = [{
        route: window.createUrl('gis'),
        routeName: 'gis',
        params: {
          templateUrl: 'templates/_guest-information.html' + __timestamp__,
          controller: 'GisController as ctrl',
          reloadOnSearch: false,
          resolve: {
            seo: ['SeoService', 'gettextCatalog', function (SeoService, gettextCatalog) {
              SeoService.generateMetaTags(gettextCatalog.getString('Guest information | PADI Travel'));
            }],
          },
        },
      }];

    _.each(routes, function (v) {
      if (!v.params.resolve) {
        v.params.resolve = {};
      }
      v.params.resolve.routeName = ['$rootScope', function ($rootScope) {
        $rootScope.routeName = v.routeName;
        return v.routeName;
      }];
      v.params.resolve.lang = function () {
        return window.lang;
      };

      $routeProvider.when(v.route, v.params);
    });

    $routeProvider
      .when('/widget/:id', {
        templateUrl: 'templates/widget.html' + __timestamp__,
        controller: 'WidgetCtrl as widget',
        resolve: {},
      })
      .otherwise({
        templateUrl: 'templates/404.html',
        resolve: {
          pageStatus: function (check404) {
            'ngInject';

            return check404.checkUrlStatus();
          },
          error404: function () {
            return true;
          },
          seo: ['SeoService', 'gettextCatalog', function (SeoService, gettextCatalog) {
            SeoService.generateMetaTags(gettextCatalog.getString('Page not found | PADI Travel'), '');
          }],
        },
      });
  }
]);
